module.exports = __webpack_public_path__ + "img/order.5380f96a.svg";